import { ref, watch, onBeforeUnmount, computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d42880c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "batch-enable-ratio"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "batch-enable-ratio-label"
}, "价格比例:", -1));
const _hoisted_3 = {
  key: 0,
  class: "batch-enable-ratio-error"
};
const _hoisted_4 = {
  class: "batch-enable-rule"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "batch-enable-rule-strong"
}, "9", -1));
const _hoisted_6 = {
  class: "batch-enable-preview-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "价格预览", -1));
const _hoisted_8 = {
  class: "batch-enable-preview-count"
};
import { MIN_PRICE_RATIO_PERCENT } from '../services/thirdPartyPricing';
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyBatchEnableModal',
  props: {
    open: {
      type: Boolean
    },
    payChnl: null,
    prodChnl: null,
    preview: null,
    priceRatio: null,
    showPriceRatio: {
      type: Boolean
    },
    confirmCount: null,
    canConfirm: {
      type: Boolean
    },
    previewLoading: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:priceRatio", "preview", "confirm", "cancel"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 只允许 70~100 的整数：输入阶段直接丢掉小数点与非数字字符，避免出现 1.5 / -1 / 1e3
    const parseRatio = displayValue => (displayValue || '').replace(/[^\d]/g, '').slice(0, 3);
    const ratioError = ref('');
    // 防抖等待中：与 previewLoading 一起驱动表格 loading，并在此期间禁用确认按钮
    const ratioPending = ref(false);
    const RATIO_DEBOUNCE = 500;
    let ratioTimer = null;
    const clearRatioTimer = () => {
      if (ratioTimer) {
        clearTimeout(ratioTimer);
        ratioTimer = null;
      }
    };
    const isValidRatio = value => value !== null && Number.isInteger(value) && value >= MIN_PRICE_RATIO_PERCENT && value <= 100;
    // 输入即防抖预览：校验通过才发请求，非法值只提示不请求
    const onRatioInput = value => {
      const num = value === null || value === '' ? null : Number(value);
      emit('update:priceRatio', num);
      clearRatioTimer();
      if (!isValidRatio(num)) {
        ratioPending.value = false;
        ratioError.value = num === null ? '' : `价格比例需为 ${MIN_PRICE_RATIO_PERCENT}~100 的整数`;
        return;
      }
      ratioError.value = '';
      ratioPending.value = true;
      ratioTimer = setTimeout(() => {
        ratioTimer = null;
        emit('preview');
        // runPreview 会同步置上 previewLoading，交接过去后本地 pending 即可释放
        ratioPending.value = false;
      }, RATIO_DEBOUNCE);
    };
    // 失焦 / 回车时不再等防抖，立即预览
    const flushRatioPreview = () => {
      if (!ratioTimer) return;
      clearRatioTimer();
      emit('preview');
      ratioPending.value = false;
    };
    // 关闭再打开时清掉上一次的报错与待发请求
    watch(() => props.open, open => {
      if (!open) {
        clearRatioTimer();
        ratioPending.value = false;
        ratioError.value = '';
      }
    });
    onBeforeUnmount(clearRatioTimer);
    const channelName = computed(() => props.payChnl === 'xsolla_pay' ? 'Xsolla' : 'Enjoy');
    // 官方价格来自当前列表渠道：谷歌列表下是谷歌价格，其余（iOS）是苹果价格
    const officialName = computed(() => props.prodChnl === 'google' ? '谷歌' : '苹果');
    const columns = computed(() => [{
      title: '商品名称',
      dataIndex: 'productName',
      ellipsis: true
    }, {
      title: `${officialName.value}价格`,
      dataIndex: 'officialPrice',
      width: 130
    }, {
      title: `${channelName.value} 价格`,
      dataIndex: 'targetPrice',
      width: 130
    }, {
      title: '价格处理',
      dataIndex: 'priceProcess',
      width: 120
    }]);
    // 缺价且未传比例时目标价可能缺失 / null / 空串，统一展示 --
    const formatPrice = (currency, price) => price === undefined || price === null || price === '' ? '--' : `${currency || 'USD'} ${price}`;
    const processText = value => ({
      EXISTING_PRICE: '沿用已有价',
      GENERATED_BY_RATIO: '按比例生成',
      NOT_OPERABLE: '不可操作'
    })[value] || '--';
    return (_ctx, _cache) => {
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: `批量开启 ${_unref(channelName)} 支付`,
        width: 680,
        "confirm-loading": __props.submitLoading,
        "ok-text": `确认批量开启（${__props.confirmCount}）`,
        "cancel-text": "取消",
        "ok-button-props": {
          disabled: !__props.canConfirm || ratioPending.value
        },
        onOk: _cache[0] || (_cache[0] = $event => _ctx.$emit('confirm')),
        onCancel: _cache[1] || (_cache[1] = $event => _ctx.$emit('cancel'))
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: __props.previewLoading || ratioPending.value
        }, {
          default: _withCtx(() => {
            var _props$preview2;
            return [_createVNode(_component_a_alert, {
              type: "info",
              "show-icon": "",
              class: "batch-enable-summary"
            }, {
              message: _withCtx(() => {
                var _props$preview$exist, _props$preview;
                return [_createTextVNode(" 本次开启 " + _toDisplayString(__props.confirmCount) + " 个商品，其中 " + _toDisplayString((_props$preview$exist = (_props$preview = __props.preview) === null || _props$preview === void 0 ? void 0 : _props$preview.existingPriceCount) !== null && _props$preview$exist !== void 0 ? _props$preview$exist : 0) + " 个已配置过" + _toDisplayString(_unref(channelName).toLowerCase()) + "价格。 ", 1)];
              }),
              _: 1
            }), __props.showPriceRatio ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_input_number, {
              value: __props.priceRatio,
              min: _unref(MIN_PRICE_RATIO_PERCENT),
              max: 100,
              precision: 0,
              step: 1,
              controls: false,
              parser: parseRatio,
              status: ratioError.value ? 'error' : '',
              class: "batch-enable-ratio-input",
              "addon-after": "%",
              placeholder: "70~100",
              "onUpdate:value": onRatioInput,
              onBlur: flushRatioPreview,
              onPressEnter: flushRatioPreview
            }, null, 8, ["value", "min", "status"]), ratioError.value ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(ratioError.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createTextVNode(" 计算规则：三方价格 = " + _toDisplayString(_unref(officialName)) + "官方价格 × 价格比例。非整数价格将自动把小数点第二位调整为 ", 1), _hoisted_5, _createTextVNode("，整数价格不做调整。 ")])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, "本次开启 " + _toDisplayString(__props.confirmCount) + " 个商品", 1)]), _createVNode(_component_a_table, {
              class: "batch-enable-table",
              columns: _unref(columns),
              "data-source": ((_props$preview2 = __props.preview) === null || _props$preview2 === void 0 ? void 0 : _props$preview2.items) || [],
              "row-key": "productId",
              size: "small",
              pagination: false,
              scroll: {
                y: 240
              }
            }, {
              bodyCell: _withCtx(({
                column,
                record
              }) => [column.dataIndex === 'officialPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createTextVNode(_toDisplayString(formatPrice(record.currency, record.officialPrice)), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'targetPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createTextVNode(_toDisplayString(formatPrice(record.currency, record.targetPrice)), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'priceProcess' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [record.priceProcess === 'NOT_OPERABLE' ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                title: record.inoperableReason
              }, {
                default: _withCtx(() => [_createVNode(_component_a_tag, {
                  color: "error"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(processText(record.priceProcess)), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["title"])) : record.priceProcess === 'GENERATED_BY_RATIO' ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 1,
                class: "tag-generated-price"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(processText(record.priceProcess)), 1)]),
                _: 2
              }, 1024)) : (_openBlock(), _createBlock(_component_a_tag, {
                key: 2,
                class: "tag-existing-price"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(processText(record.priceProcess)), 1)]),
                _: 2
              }, 1024))], 64)) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["columns", "data-source"])];
          }),
          _: 1
        }, 8, ["spinning"])]),
        _: 1
      }, 8, ["open", "title", "confirm-loading", "ok-text", "ok-button-props"]);
    };
  }
});